export const adaptiveTestVersions = {
  Abstract: ["ADAPTG2A", "ADAPTGA", "ADAPTGRTA"],
  Numerical: ["ADAPTG2N", "ADAPTGN", "ADAPTGRTN"],
  Verbal: ["ADAPTG2V", "ADAPTGV", "ADAPTGRTV"],
};
